export default {"src":"/_next/static/media/subSol4.15229427.svg","height":58,"width":62};